function getWordsCount (text:string) {
    if (text) {
        return text.trim().split(" ").length;
    }
    return 0;
}

export default getWordsCount;



// WEBPACK FOOTER //
// ./src/utils/WordsCount.ts